<template>
    <div id="listcontent"  class="cmv-listcontent">
        <div class="cm-customercenter-history-container" id="historyContainer">
            <form class="px-xl-3">
                <div class="form-group row">
                    <label class="pr-0 col-sm-2 col-form-label">{{$t('historyListContent.Game')}}</label>
                    <div class="col-sm-10">
                        <select v-model="selectedGameCode" class="form-control form-control-lg cm-customercenter-history-select">
                            <option value="" selected="selected">{{$t('historyListContent.Game.Select.All')}}</option>
                            <option v-for="(obj, index) in gameCodeAndName" :key="index" :value="obj.gameCode">{{obj.gameName}}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="pr-0 col-sm-2 col-form-label">{{$t('historyListContent.Item.Status')}}</label>
                    <div class="col-sm-10">
                        <select v-model="selectedStatus" class="form-control form-control-lg cm-customercenter-history-select">
                            <option value="">{{$t('historyListContent.Item.Status.Select.All')}}</option>
                            <option value="processing" selected="selected" >{{$t('historyListContent.Item.Status.Select.Processing')}}</option>
                            <option value="replied">{{$t('historyListContent.Item.Status.Select.Processed')}}</option>
                            <option value="finished">{{$t('historyListContent.Item.Status.Select.CaseClosed')}}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group row d-flex align-items-center cm-customercenter-history-querydate">
                    <label class="pr-0 col-2 col-form-label">{{$t('historyListContent.Item.Time')}}</label>
                    <div class="col-10 row mx-0 d-flex align-items-center">
                        <div id="cm_datepicker" class="pl-1 col-9 row mx-0 input-group input-daterange cm-customercenter-history-querydate-date">
                            <v-date-picker :input-props='{readonly: true}' id="datepicker1" v-model='selectedDateFrom' :formats='datePickerFormats()'/>
                            <div class="input-group-addon d-flex align-items-center justify-content-center mx-1 col-sm-1 col-12">{{$t('historyListContent.Item.Time.TO')}}</div>
                            <v-date-picker :input-props='{readonly: true}' id="datepicker2" v-model='selectedDateTo' :formats='datePickerFormats()'/>
                        </div>
                        <div class="col-3 px-1 d-flex align-items-center cm-customercenter-history-querydate-query">
                            <button @click.prevent="clientQueryHistoryList()" class="text-nowrap">{{$t('historyListContent.Item.Time.Button.Submit')}}</button>
                        </div>
                    </div>
                </div>
            </form>
            <div v-if="isShowHistoryListTable==true">
                <b-row class="my-3 cmv-listcontent-table-top">
                    <!-- search -->
                    <div class="col-md-2">
                        {{$t('historyListContent.Filter.Search')}}
                    </div>
                    <div class="col-md-4 cmv-listcontent-table-filter">
                        <b-input-group>
                            <b-form-input v-model="filter" :placeholder="$t('historyListContent.Filter.Search.Placeholder')" />
                            <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''">{{$t('historyListContent.Filter.Search.Clear')}}</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </div>
                    
                    <!-- search -->
                    <div class="col-md-2 offset-md-2">
                        {{$t('historyListContent.Filter.Pages')}}
                    </div>
                    <div class="col-md-2 cmv-listcontent-table-page">
                        <b-form-group>
                            <b-form-select :options="pageOptions" v-model="perPage" />
                        </b-form-group>
                    </div>
                </b-row>
    
                <b-table class="table table-striped table-bordered cm-customercenter-history-table"
                    show-empty
                    :current-page = currentPage
                    :empty-filtered-text = emptyFilteredText
                    :fields = bTableFields()
                    :filter = filter
                    :items = items
                    :per-page = perPage
                    :sort-by.sync = sortBy
                    :sort-desc.sync = sortDesc
                    @filtered="onFiltered"
                    style="word-wrap:break-word; word-break: break-all"
                >
                    <!-- 標題 -->
                    <template v-slot:cell(questionTitle)="data">
                        <span v-html="data.value"></span>
                    </template>

                    <!-- "查看內容"按鈕-->
                    <template v-slot:cell(operate)="data">
                        <a data-toggle="modal" data-target="#contentModal" :data-num="data.value.num">{{ data.value.buttonValue }}</a>
                    </template>
                </b-table>
                
                <b-row>
                    <b-col>
                        <b-pagination align="center"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        v-model="currentPage"
                        class="cmv-listcontent-table-pagination"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col align="center">
                        {{$t('historyListContent.Table.TotalRecords.sent1')}} {{filterHistories.length}} {{$t('historyListContent.Table.TotalRecords.sent2')}}
                    </b-col>
                </b-row>
            </div>

            <div v-if="isShowHistoryListTable==false" class="cmv-listcontent-no-data cm-customercenter-history-table">
                <table class="cmv-listcontent-inquire-result">
                    <tr>
                        <th>{{$t('historyListContent.Table.Column.Status')}}</th>
                        <th>{{$t('historyListContent.Table.Column.InquiryTicket')}}</th>
                        <th>{{$t('historyListContent.Table.Column.InquiryTime')}}</th>
                        <th>{{$t('historyListContent.Table.Column.Type')}}</th>
                        <th>{{$t('historyListContent.Table.Column.Title')}}</th>
                        <th>{{$t('historyListContent.Table.Column.Operate')}}</th>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </table>
            </div>
            <div id="questionHyperlink" style="display:none;" :data-query_cs="monitorUrlQuickQueryCs"></div>
        </div>
        
        
        <!------------------------------查看內容開始------------------------------>
        <div class="modal fade cm-modal" id="contentModal" tabindex="-1" role="dialog" aria-labelledby="contentModalTitle"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header align-middle cm-morecontent-header">
                        <h4 class='col-12 modal-title text-center text-white'>
                            {{$t('historyListContent.Modal.Title.InquiryTicket')}}: {{modalInfoOrderId}}
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true"><img src="../assets/images/login-close.png" alt="" class="cm-morecontent-close"></span>
                            </button>
                        </h4>
                    </div>
                    <div class="modal-body">
                        <div class="row cm-morecontent-info-container">
                            <div class="col-md-6 col-12 px-md-5">
                                <div class="row">
                                    <div class="col-md-3 col-sm-2 col-3 d-flex justify-content-start text-nowrap cm-morecontent-info-text">
                                        {{$t('historyListContent.Modal.Info.Game')}}:
                                    </div>
                                    <div class="col-md-9 col-sm-10 col-9 d-flex justify-content-start cm-morecontent-info-text" v-html="modalInfoGame">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-3 col-sm-2 col-3 d-flex justify-content-start text-nowrap cm-morecontent-info-text">
                                        {{$t('historyListContent.Modal.Info.Role')}}:
                                    </div>
                                    <div class="col-md-9 col-sm-10 col-9 d-flex justify-content-start cm-morecontent-info-text" v-html="modalInfoRole">
                                    </div>
                                </div>
                                <!-- 2020/10/12對應新的客服頁面，主題欄位不再顯示
                                <div class="row">
                                    <div class="col-md-3 col-sm-2 col-3 d-flex justify-content-start text-nowrap cm-morecontent-info-text">
                                        {{$t('historyListContent.Modal.Info.Title')}}:
                                    </div>
                                    <div class="col-md-9 col-sm-10 col-9 d-flex justify-content-start cm-morecontent-info-text" v-html="modalInfoTitle">
                                    </div>
                                </div>
                                -->
                            </div>
                            <div class="col-md-6 col-12 px-md-5">
                                <div class="row">
                                    <div class="col-md-4 col-sm-2 col-3 d-flex justify-content-start text-nowrap cm-morecontent-info-text">
                                        {{$t('historyListContent.Modal.Info.Server')}}:
                                    </div>
                                    <div class="col-md-8 col-sm-10 col-9 d-flex justify-content-start cm-morecontent-info-text" v-html="modalInfoServer">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4 col-sm-2 col-3 d-flex justify-content-start text-nowrap cm-morecontent-info-text">
                                        {{$t('historyListContent.Modal.Info.Time')}}:
                                    </div>
                                    <div class="col-md-8 col-sm-10 col-9 d-flex justify-content-start cm-morecontent-info-text">
                                        {{modalInfoTime}}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4 col-sm-2 col-3 d-flex justify-content-start text-nowrap cm-morecontent-info-text">
                                        {{$t('historyListContent.Modal.Info.Type')}}:
                                    </div>
                                    <div class="col-md-8 col-sm-10 col-9 d-flex justify-content-start cm-morecontent-info-text" v-html="modalInfoType">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="cm-morecontent-talk-container" v-html="modalRecordDetail" @click="zoomImgAndScore($event)">                            
                        </div>
                                                                           
                        <form v-if="modalShowFormElement" class="py-2 cm-morecontent-form">
                            <textarea v-model="modalAsk" class="form-control cm-morecontent-form-textarea"></textarea>
                            <label class="text-danger" v-if="modalAskReq">{{$t('historyListContent.Modal.Ask.Req')}}</label>
                            <label class="text-danger" v-if="modalAskSpecialSymbols">{{$t('historyListContent.Modal.Ask.SpecialSymbols')}}</label>
                            <div class="py-2">
                                <a @click="addImg" class="cm-morecontent-form-uploadimg-btn">{{$t('historyListContent.Modal.Button.Screenshot')}}</a>
                            </div>
                            <label class="error" style="color:red" v-if="Imglimit">{{$t('contactus.Button.Screenshot.Max')}}</label>
                            <p class="cm-morecontent-form-uploadimg-prompt">{{$t('historyListContent.Modal.Button.Screenshot.Prompt')}}</p>
                            <ul id="uploadImagesList" class="px-4 py-1">
                                <li v-for="(img,index) in ImgList" class="row py-1" :key="img.id">
                                    <label class="col-sm-10" style="padding: 0 0 0 0;">
                                        <input type="file" 
                                        :id="'IMG'+img.id"
                                        class="col-sm-6 imageDummy" 
                                        style="padding: 0 0 0 0;" 
                                        @change="ImgCheck($event,img.id,index)"
                                        accept="image/jpeg,image/jpg,image/png,image/bmp"/>
                                    </label>
                                    <a class="col-sm-2 cm-morecontent-form-uploadimg-delete-btn" 
                                    @click="delImg(index)">
                                        {{img.del}}
                                    </a>
                                </li>
                            </ul>
                            <div class="d-flex justify-content-center">
                                <div v-if="isWaitingModalSubmit==true" class="spinner-border text-warning text-center d-block"></div>
                                <a v-if="isWaitingModalSubmit!=true" @click="modalSubmit" class="d-flex justify-content-center cm-morecontent-form-send-btn">{{$t('historyListContent.Modal.Button.Confirm')}}</a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <img id="detecImgLoad" src="" style="display:none">
        <!------------------------------查看內容結束------------------------------>
    </div>
</template>

<script>
import Vue from 'vue'
import VCalendar from 'v-calendar'
import axios from 'axios'
import $ from 'jquery'
import {cm_navbar_mobile_close} from '@/assets/js/cm-navbar.js'
import store from '@/store/store-controller/store.js'
import router from '@/router.js'
import CookieUtil from '@/assets/js/util/CookieUtil.js'
import ShowMsg from '@/assets/js/util/ShowMsg.js'
import TimeUtil from '@/assets/js/util/TimeUtil.js'
import ValidatorUtil from "@/assets/js/util/ValidatorUtil.js";

var imgCount = 0;
var asyncTry;

export default {
    name: "listcontent",
    data() {
        return {
            gameCodeAndName: [],
            selectedGameCode: "", // 選擇要查詢的遊戲
            selectedStatus: "", // 選擇處理進度
            selectedDateFrom: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()-6),
            selectedDateTo: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 59),
            isShowHistoryListTable: false, // 有資料需要列出時為true，反之
            filterHistories: [], // 顯示於頁面上的客服紀錄
            filterHistoriesLength: 0,
            pageOptions: [5, 10, 15],
            perPage: 5,
            currentPage: 1,
            emptyFilteredText: this.$i18n.t('historyListContent.Table.NoRecords'),
            filter: null,
            sortBy: "orderId",
            sortDesc: true,
            queryType: {
                init: "init", // ajax取得所有資料
                filter: "filter", // 依照client選擇的篩選過去資料
                all: "all" // 列出所有資料
            },
            
            // modal的確認按鈕控制動畫
            isWaitingModalSubmit: false,
            
            // modal中要顯示的客服紀錄資訊
            modalInfoNum: "",
            modalInfoOrderId: "",
            modalInfoGame: "",
            modalInfoRole: "",
            modalInfoServer: "",
            modalInfoTime: "",
            modalInfoTitle: "",
            modalInfoType: "",
            modalRecordDetail: "",
            modalAsk: "",
            modalAskReq: false,
            modalAskSpecialSymbols: false,
            modalShowFormElement: false,
            modalProcessing: false,
            modalAskImgStyle: "max-width: 100px;", // modal中<img>所使用的style            

            // modal中上傳圖片相關
            Imglimit: false,
            ImgList: [],
            uploadImgList: [],

            // modal中已結案客訴單user選擇評價
            isUserScoredCS: false,
            modalUserScore: "",
            // zendesk : null,
            stateMounted: false,
        };
    },
    computed: {
        totalRows: function() {
            if(this.filterHistoriesLength) {
                return this.filterHistoriesLength;
            }
            return this.filterHistories.length;
        },
        items: function() {
            let questionStatus = this.getQuestionStatusLanguage();
            let questionCategory = this.getQuestionCategoryLanguage();
            let data = [];
            for(let i=0; i<this.filterHistories.length; i++) {
                let question = Object();
                question = Object.assign(question, this.filterHistories[i]);
                question.status = questionStatus[question.status];
                question.questionCategory = questionCategory[question.questionCategory];
                question.createDate = TimeUtil.dateAndTimeFromTimestamp(question.createDate);
                question.operate = {
                    buttonValue: this.$i18n.t('historyListContent.Table.Row.Button.CheckContent'),
                    num: question.num
                }

                data.push(question);
            }
            return data;
        },
        
        monitorUrlQuickQueryCs: function() {
            if(this.stateMounted) {
                if(document.querySelector("#contentModal").classList.contains("show")) {
                    $('#contentModal').modal('hide');
                }
                const self = this;
                setTimeout(() => {
                    self.urlQuickQueryCs("computed");    
                }, 500);
            }
            return this.$route.query.cs;
        }      
    },
    watch: {
        perPage: function() {
            this.currentPage = 1;
        }
    },
    created() {
        this.initHistoryList();
    },
    mounted() {
        this.stateMounted = true;

        const self = this;
        document.querySelector("#historyContainer").addEventListener("click", function(e) {
            if(e.target.dataset.target == "#contentModal") {
                self.setQuestionInfoToModal(e.target.dataset.num);
            }
        })

        // 根據URL的cs參數代入客服單
        if(this.$route.query.cs!=undefined) {
            this.urlQuickQueryCs();
        }
    },
    methods: {
        zoomImgAndScore(event) {            
            if(event.target.dataset['type'] == "img") {
                ShowMsg.showModal(`<div><img src=${event.target.src} class="img-fluid"></div>`);
            }else if (event.target.dataset['type'] == "icon"){                
                this.userScoring(event.target.dataset['num']);
            }else if (event.target.dataset['type'] == "button"){
                if (this.modalUserScore == "" || this.modalUserScore == 0){
                    alert(this.$i18n.t('historyListContent.Modal.Prompt.ScoreRequire'));
                }else{
                    this.scoreSubmit();
                }
            }
        },
        getQuestionStatusLanguage() {
            return {
                all: this.$i18n.t('historyListContent.Table.Status.All'),
                finished: this.$i18n.t('historyListContent.Table.Status.Finished'),
                new: this.$i18n.t('historyListContent.Table.Status.New'),
                processing: this.$i18n.t('historyListContent.Table.Status.Processing'),
                replied: this.$i18n.t('historyListContent.Table.Status.Replied')
            }
        },
        getQuestionCategoryLanguage() {
            return {
                depositQA: this.$i18n.t('historyListContent.Table.Ask.QuestionCategory.DepositQA'),
                gameQA: this.$i18n.t('historyListContent.Table.Ask.QuestionCategory.GameQA'),
                gametaiwanQA: this.$i18n.t('historyListContent.Table.Ask.QuestionCategory.GametaiwanQA'),
                loginQA: this.$i18n.t('historyListContent.Table.Ask.QuestionCategory.LoginQA'),
                othersQA: this.$i18n.t('historyListContent.Table.Ask.QuestionCategory.OthersQA')
            }
        },
        datePickerFormats() {
            const self = this
            let format = {
                title: "MMMM YYYY",
                weekdays: "W",
                navMonths: "MMM",
                input: ["YYYY-MM-DD"], // Only for `v-date-picker`
                dayPopover: "L", // Only for `v-date-picker`
                data: ["YYYY-MM-DD"], // For attribute dates
                align: "center"
            }
            
            Vue._installedPlugins.find(function(plugin){
                if(plugin.hasOwnProperty('Calendar')){
                    plugin.install(Vue, { 
                        locale: self.$i18n.locale,
                        formats: format
                    })
                }
            });
        },
        bTableFields() {
            return [
                { key: "status", label: this.$i18n.t('historyListContent.Table.Column.Status'), sortable: true },
                { key: "orderId", label: this.$i18n.t('historyListContent.Table.Column.InquiryTicket'), sortable: true },
                { key: "createDate", label: this.$i18n.t('historyListContent.Table.Column.InquiryTime'), sortable: true },
                { key: "questionCategory", label: this.$i18n.t('historyListContent.Table.Column.Type'), sortable: true },
                //{ key: "questionTitle", label: this.$i18n.t('historyListContent.Table.Column.Title'), sortable: true }, // 2020/10/12對應新的客服頁面，主題欄位不再顯示
                { key: "operate", label: this.$i18n.t('historyListContent.Table.Column.Operate')}
            ]
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.filterHistoriesLength = filteredItems.length;
            this.currentPage = 1;
        },
        urlQuickQueryCs() {
            if(this.$route.query.cs!=undefined
             && document.querySelector("#contentModal").classList.contains("show") == false
             && this.modalProcessing == false) {
                let aTag = document.createElement("a");
                aTag.id="aTag";
                aTag.dataset.toggle = "modal";
                aTag.dataset.target = "#contentModal";
                aTag.dataset.num = this.$route.query.cs; // 客服單號
                document.querySelector("#questionHyperlink").innerHTML = "";
                document.querySelector("#questionHyperlink").appendChild(aTag);
                aTag.click();
            }
        },
        async ajaxHistoryList() {
            let self = this;
            return new Promise(function(resolve) {
                let allHistories = [];
                if(CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE)!==false) {
                    let bodyFormData = new FormData();
                    bodyFormData.append("gameCode", self.selectedGameCode);
                    bodyFormData.append("askQuestionRecordKey", CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE));
                    bodyFormData.append("customerComplaintCondition.fkMember", "0");
                    bodyFormData.append("customerComplaintCondition.status", self.selectedStatus);
                    bodyFormData.append("beginCreateDate", new Date(self.selectedDateFrom).getTime());
                    bodyFormData.append("endCreateDate", (new Date(self.selectedDateTo).getTime() + 86399999)); // 86399999 = 23:59:59.999

                    axios({
                        method: "post",
                        url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/frontendSearchCustomerComplaintJsonAction.shtml",
                        timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                        data: bodyFormData,
                        config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
                    })
                    .then(function(response) {
                        if(response.data.status=="success" && response.data.resultCount>0) { // success
                            allHistories = response.data.results;
                        }
                        resolve(allHistories)
                    })
                    .catch(function(response) {
                        console.log(response);
                        alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
                        router.push({name: process.env.VUE_APP_ROUTER_HOME});
                        resolve(allHistories);
                    })
                }
                else {
                    // 如果是未登入狀態則顯示loginModal讓玩家登入，記下cookie方便玩家登入完畢後再回來
                    cm_navbar_mobile_close();
                    document.querySelector("#loginModalHyperlink").click();
                    if(router.currentRoute.name == process.env.VUE_APP_ROUTER_HISTORY_LIST) {
                        CookieUtil.commonSetCookie(process.env.VUE_APP_COOKIE_FRONTEND_ROUTER_PUSH, router.currentRoute.name);
                    }
                    router.push({name: process.env.VUE_APP_ROUTER_HOME});
                    resolve(allHistories);
                }
            })

        },
        async initHistoryList() { // 第一次進頁面時將所有客服紀錄列出
            this.clientQueryHistoryList();
            this.gameCodeAndName = []
            if(CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE)!==false)
            {
                this.insertActionDOM();
            }
        },
        // 遠端取得儲值選項
        async insertActionDOM() { //為了繞過CORS問題
            if(document.querySelectorAll("head script[src='" + 
            process.env.VUE_APP_URL_DOMAIN_LOGIN + "/initMdepositJsonAction.shtml?paymentStatus=3" +
            "']").length <= 0)
            {
                let redirectDepositPage = document.createElement("script");
                redirectDepositPage.setAttribute("src", process.env.VUE_APP_URL_DOMAIN_LOGIN + "/initMdepositJsonAction.shtml?paymentStatus=3");
                document.head.appendChild(redirectDepositPage);
            }
            await this.checkInitData();
        },
        // 確認遠端取得儲值選項是否成功
        checkInitData()
        {
            let self = this;
            let count = 0;
            let waitSecond = 1000;
            let limitN = process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND / waitSecond;
            asyncTry = setInterval(function(){
                try {
                    if(remoteDepositInfo) {
                        self.setInitData();
                    }
                }
                catch(e) {}
                if(count >= limitN )
                {
                    clearInterval(asyncTry);
                    alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
                    return;
                }
                count ++;
            },waitSecond);
        },
        // 初始化遊戲選項
        async setInitData() {
            try{
                clearInterval(asyncTry);
                let gameInfo = JSON.parse(remoteDepositInfo.getGameServer())
                let gameCodes = Object.keys(gameInfo)
                for(let i=0; i<gameCodes.length; i++) {
                    const gameCode = gameCodes[i]
                    let game = {
                        gameCode: gameInfo[gameCode]['gameCode'],
                        gameName: gameInfo[gameCode]['gameName'],
                    }
                    this.gameCodeAndName.push(game)
                }
            }
            catch(err)
            {
                console.log(err);
                alert(this.$i18n.t('common.PleaseLogin'));
                router.push({name: process.env.VUE_APP_ROUTER_HOME});
            }
        },
        async clientQueryHistoryList() { // client點擊按鈕查詢
            const selectedDateFrom = new Date(this.selectedDateFrom).getTime();
            const selectedDateTo = new Date(this.selectedDateTo).getTime();
            if(selectedDateTo < selectedDateFrom) {
                alert(this.$i18n.t('historyListContent.Alert.Date.Query.EndDateGreaterStartDate'));
                return;
            }
            this.filterHistories = await this.ajaxHistoryList();
            this.isShowHistoryListTable = (this.filterHistories.length > 0) ? true : false;
        },
        async ajaxCustomerDiscussInfo(num) { // Ajax取得客服紀錄基本資訊(會員於提問時所填的資訊)
            let self = this;
            return new Promise(function(resolve) {
                // ajax
                let bodyFormData = new FormData();
                bodyFormData.append("qaKey", CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE));
                bodyFormData.append("num", num);
                axios({
                    method: "post",
                    url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/initCustomerJoinDiscussJsonAction.shtml",
                    timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                    data: bodyFormData,
                    config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
                })
                .then(function(response) {
                    if(response.data.result=="success") {
                        resolve(response.data);
                    }
                    resolve(null);
                })
                .catch(function(response) {
                    console.log(response);
                    alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
                    resolve(null);
                })
            })
        },
        async ajaxCustomerAllDiscuss(num) { // Ajax取得客服紀錄中客服與會員的所有對話
            let self = this;
            return new Promise(function(resolve) {
                // ajax
                let bodyFormData = new FormData();
                bodyFormData.append("sendMSGKey", CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE));
                bodyFormData.append("questionDiscussCondition.fkCustomerComplaint", num);
                bodyFormData.append("from", 'taiyou2');
                axios({
                    method: "post",
                    url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/frontendGetAllDiscussByFKCustomerAction.shtml",
                    timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                    data: bodyFormData,
                    config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
                })
                .then(function(response) {
                    if(response.data.result=="success") {
                        resolve(response.data);
                    }
                    resolve(null);
                })
                .catch(function(response) {
                    console.log(response);
                    console.log(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
                    resolve(null);
                })
            })
        },
        async setQuestionInfoToModal(num) {
            if(num<=0) {
                return
            }
            else {
                this.modalInfoNum = num;
                this.modalProcessComplete = true;
            }
            
            if(CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE)!==false) {
                const questionCategory = this.getQuestionCategoryLanguage();
                
                // 清空
                this.modalInfoOrderId = "";
                this.modalInfoGame = "";
                this.modalInfoRole = "";
                this.modalInfoServer = "";
                this.modalInfoTime = "";
                this.modalInfoTitle = "";
                this.modalInfoType = "";
                this.modalRecordDetail = "";
                this.modalAsk = "";
                this.modalAskReq = false;
                this.modalAskSpecialSymbols = false;
                this.ImgList = [];
                this.uploadImgList = [];
                
                const response = await this.ajaxCustomerDiscussInfo(parseInt(this.modalInfoNum));
                const response2 = await this.ajaxCustomerAllDiscuss(parseInt(this.modalInfoNum));

                if(response!=undefined && response.result!==undefined && response!=null && response.result=="success") {
                    this.modalInfoOrderId = response.orderId == undefined ? "" : response.orderId;
                    this.modalInfoGame = response.gameName == undefined ? "" : response.gameName;
                    this.modalInfoRole = response.gameCharacterName == undefined ? "" : response.gameCharacterName;
                    this.modalInfoServer = response.gameServerName == undefined ? "" : response.gameServerName;
                    this.modalInfoTime = response.createDate == undefined ? "" : TimeUtil.dateAndTimeFromTimestamp(response.createDate);
                    this.modalInfoTitle = response.questionTitle == undefined ? "" : response.questionTitle;
                    this.modalInfoType = response.questionCategory == undefined ? "" : questionCategory[response.questionCategory];
                    this.modalShowFormElement = (response.status == "finished" ? false : true); // 已結案的客訴單隱藏對話功能
                    this.isUserScoredCS = (response.score == undefined ? false : true) ; //玩家是否已經填寫過滿意度
                    this.modalUserScore = response.score == undefined ? "" : response.score;

                            
                    // 圖片
                    let imgHtml = "";
                    if(response.pictureFilePathAry!=undefined && response.pictureFilePathAry.length>0) {
                        for(let i=0; i<response.pictureFilePathAry.length; i++) {
                            imgHtml += `<img style="${this.modalAskImgStyle}" src="${response.pictureFilePathAry[i]}" data-type="img">`
                        }
                    }
                    this.modalRecordDetail = `
                        <div class="cm-morecontent-user">
                            <div class="cm-morecontent-user-talk">
                                ${response.questionDescription.replace(/&lt;br &#x2f;&gt;/g, "<br />")}
                                ${imgHtml}
                            </div>
                            <div class="cm-morecontent-talk-time">${TimeUtil.dateAndTimeFromTimestamp(response.createDate)}</div>
                        </div>
                    `;
                }

                // 在客服回覆所插入的<img>中加入data-type="img"，點選圖片時才會使用modal顯示
                this.$nextTick(function () {
                    let imgList = document.querySelectorAll(".cm-morecontent-company-talk img");
                    for(let i=0; i<imgList.length; i++) {
                        let imgEle = imgList[i];
                        imgEle.style = this.modalAskImgStyle;
                        imgEle.dataset["type"] = "img";
                    }
                })

                if(response2!=undefined && response2.result!==undefined && response2!=null && response2.result=="success" && response2.questionDiscussSearchResult!="") {
                    if(response2.questionDiscussSearchResult.results.length > 0) {
                        const results = response2.questionDiscussSearchResult.results;
                        for(let i=0; i<results.length; i++) {
                            const result = results[i];
                            // 圖片
                            let imgHtml = "";
                            for(let j=0; j<result.pictureFilePathAry.length; j++) {
                                imgHtml += `<img style="max-width:100px" src="${result.pictureFilePathAry[j]}" data-type="img">`
                            }
                            // 對話內容
                            if(result.speakerGroup == "Customer") {
                                this.modalRecordDetail += `
                                    <div class="cm-morecontent-user">
                                        <div class="cm-morecontent-user-talk">
                                            ${result.discus.replace(/&#xa;/g, "<br />")}
                                            ${imgHtml}
                                        </div>
                                        <div class="cm-morecontent-talk-time">${TimeUtil.dateAndTimeFromTimestamp(result.createDate)}</div>
                                    </div>
                                `;
                            }
                            else {
                                this.modalRecordDetail += `
                                    <div class="cm-morecontent-company">
                                        <div class="cm-morecontent-talk-time">${TimeUtil.dateAndTimeFromTimestamp(result.createDate)}</div>
                                        <div class="cm-morecontent-company-talk">
                                            ${result.discus}
                                            ${imgHtml}
                                        </div>
                                    </div>
                                `;
                            }
                        }
                    }  
                }
            }
            else {
                alert(this.$i18n.t('common.PleaseLogin'));
                router.push({name: process.env.VUE_APP_ROUTER_HOME});
            }
            
            if (!this.modalShowFormElement){
                this.modalRecordDetail += `
                    <div class="cm-morecontent-company">
                        <div class="cm-morecontent-talk-time"></div>
                        <div class="cm-morecontent-company-talk"> 
                        ` + this.$i18n.t('historyListContent.Modal.Prompt.ScoreStart') +`
                        </div>
                    </div>
                    <div class="cm-morecontent-user">
                        <div class="cm-morecontent-user-talk">
                            <div class="cm-morecontent-user-score5"><a class="cm-morecontent-user-scoreIcon"></a></div>
                            <div class="cm-morecontent-user-score4"><a class="cm-morecontent-user-scoreIcon"></a></div>
                            <div class="cm-morecontent-user-score3"><a class="cm-morecontent-user-scoreIcon"></a></div>
                            <div class="cm-morecontent-user-score2"><a class="cm-morecontent-user-scoreIcon"></a></div>
                            <div class="cm-morecontent-user-score1"><a class="cm-morecontent-user-scoreIcon"></a></div>
                        </div>
                        <div class="cm-morecontent-talk-time">
                        <button id="scoreSubmitBtn">
                           ` + this.$i18n.t('historyListContent.Modal.Button.Confirm') +`
                        </button>
                    </div>
                </div>
                `;
                
                if (this.isUserScoredCS){
                    this.modalRecordDetail += `
                    <div class="cm-morecontent-company">
                        <div class="cm-morecontent-company-talk">
                            `+ this.$i18n.t('historyListContent.Modal.Prompt.ScoreEnd')+`
                        </div>
                    </div>
                    `;

                    this.$nextTick(function (){
                        var target = 5 - parseInt(this.modalUserScore);
                        //將玩家所評的icon反白
                        $(".cm-morecontent-user-scoreIcon").each(function(index){
                            if (index == target){
                                $(this).parent().addClass("cm-morecontent-user-score-selected");
                            }
                        });
                        //不設定dataset讓玩家無法重複評分，並隱藏submitBtn                        
                        $("#scoreSubmitBtn").hide();
                    });
                }else{                    
                    //加入type才能觸發click事件
                    this.$nextTick(function (){                        
                        let iconList = document.querySelectorAll(".cm-morecontent-user-scoreIcon");
                        for(let i=0; i<iconList.length; i++) {                            
                            iconList[i].dataset["type"] = "icon";
                            iconList[i].dataset["num"] = i+"";
                        }
                        let buttonEle = document.getElementById("scoreSubmitBtn");
                        buttonEle.dataset["type"] = "button";
                    });
                }
            }

            
            this.modalProcessComplete = false;
        },
        addImg() {
            if(3 <= this.ImgList.length) {
                this.Imglimit = true;
                return;
            }
		
            this.uploadImgList.push("");
            this.ImgList.push({
                text:'上傳圖片',
                id: imgCount,
                del:this.$i18n.t('historyListContent.Modal.Button.Screenshot.Delete')
            });
            imgCount++;
        },
        delImg(index) {
            this.ImgList.splice(index,1);
            this.uploadImgList.splice(index,1);
        },
        ImgCheck(e,id,index) {
            let file = e.target.files[0];
            var name = file.name;
            var size = file.size;
            var type = file.type;
            
            if(size > 1024 * 1024 * 5) {
                alert(this.$i18n.t('historyListContent.Alert.Image.Upload.Restrict'));
                $('#IMG'+id).val("");
                return;
            } else if(type != 'image/png' && type != 'image/jpg'
                && type != 'image/bmp' && type != 'image/jpeg') {
                alert(this.$i18n.t('historyListContent.Alert.Image.Upload.FileExtension'));
                $('#IMG'+id).val("");
                return;
            }
            this.uploadImgList.splice(index,1,name);
        },
        async uploadImages(savepictureFileNameSetGroupList) {
            const self = this;
            return new Promise(function(resolve) {
                const imageDummyList = document.querySelectorAll(".imageDummy");
                for(let i=0; i<imageDummyList.length; i++) {
                    if(imageDummyList[i].files[0]!=undefined) {
                        let bodyFormData = new FormData();
                        bodyFormData.append("imageUploadKey", CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE));
                        bodyFormData.append("imageUploadFrom", location.protocol + "//" + location.host);
                        bodyFormData.append("mutiNum", store.getters['storeMemberInfo/getNum']);
                        bodyFormData.append("csUploadID", "");
                        bodyFormData.append("csUploadIMG", JSON.stringify(savepictureFileNameSetGroupList));
                        bodyFormData.append("upload", imageDummyList[i].files[0]);
                        axios({
                            method: "post",
                            url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/all9FunUploadImage.shtml",
                            timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                            data: bodyFormData,
                            config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
                        })
                        .then(function(response) {
                            if(response.data.result == "error") {
                                alert(self.$i18n.t('historyListContent.Modal.Prompt.UploadImgFailed'));
                            }
                        })
                        .catch(function(response) {
                            console.log(response);
                            alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
                        })
                    }
                }
                
                // 圖片上傳後端後，透過img tag載入圖片的成功或失敗來判斷後端是否已經完成
                const detecImgIntervalMilliseconds = 700; // 間隔毫秒數，每隔一段時間就載入圖片一次
                const detecImgWaitMilliseconds = 3000; // 最大等待毫秒數
                let detecImgLoad = document.querySelector("#detecImgLoad");
                detecImgLoad.style.display = "none";
                // ex: ["123.png", "359d58618706d2ba115533322c145551.png", "456.png", "fa5a71f8c7c205f5d9e784610dda5d6a.png"]
                const imgFileName = savepictureFileNameSetGroupList[1];
                const imgUrl = location.protocol + process.env.VUE_APP_URL_DOMAIN_RESOURCE_GAMETAIWAN + "/customer/" + imgFileName;
                const startDetecImgTs = new Date().getTime(); // 記錄開始讀取的timestamp
                detecImgLoad.src = imgUrl; // 載入圖片
                // 讀取完畢事件
                detecImgLoad.onload = function () {
                    detecImgLoad.dataset["milliseconds"] = (new Date().getTime() - startDetecImgTs); // 記錄經歷毫秒時間
                    resolve();
                }
                // 讀取失敗事件
                detecImgLoad.onerror = function () {
                    setTimeout(() => {
                        if((new Date().getTime() - startDetecImgTs) > detecImgWaitMilliseconds) { // 超過預設等待秒數
                            detecImgLoad.dataset["milliseconds"] = ("timeout=" + detecImgWaitMilliseconds); // 記錄失敗
                            resolve();
                        }
                        else { // 未超過等待秒數，繼續
                            detecImgLoad.src = imgUrl;
                        }
                    }, detecImgIntervalMilliseconds);
                }
            })
        },
        async modalSubmit() {
            const self = this;

            // 提示flag先設置為false
            this.modalAskReq = false;
            this.modalAskSpecialSymbols = false;

            // 檢查提問內容是否為空
            if(this.modalAsk == "") {
                this.modalAskReq = true;
                return;
            }

            // 檢查提問內容是否包含超過UTF-8 3Bytes的字元
            if(ValidatorUtil.isStringHaveUTF8MoreThen3BytesChar(this.modalAsk)) {
                this.modalAskSpecialSymbols = true;
                return;
            }

            // 取得所有欲上傳圖片的名稱
            let imageNameList = [];
            const imageDummyList = document.querySelectorAll(".imageDummy");
            for(let i=0; i<imageDummyList.length; i++) {
                if(imageDummyList[i].files[0]!=undefined && imageDummyList[i].files[0].name!=undefined) {
                    imageNameList.push(imageDummyList[i].files[0].name);
                }
            }

            // 送出modal中會員提問的內容
            if(CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE)!==false) {
                this.isWaitingModalSubmit = true;

                // POST Param
                let bodyFormData = new FormData();
                bodyFormData.append("dopictureFileNameSet", JSON.stringify(imageNameList));
                bodyFormData.append("from", "taiyou2");
                bodyFormData.append("mutiNum", store.getters['storeMemberInfo/getNum']);
                bodyFormData.append("sendMSGKey", CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE));
                bodyFormData.append("questionDiscuss.discus", this.modalAsk);
                bodyFormData.append("questionDiscuss.fkCustomerComplaint", this.modalInfoNum);
                bodyFormData.append("questionDiscussCondition.fkCustomerComplaint", this.modalInfoNum);

                // Send HTTP POST
                const response = await axios({
                    method: "post",
                    url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/frontendSendQuestionDiscussAction.shtml",
                    timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                    data: bodyFormData,
                    config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
                })
                .catch(function(response) {
                    console.log(response);
                    alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
                })

                // 判斷結果
                if(response != undefined) {
                    if(response.data.result=="SUCCESS") {
                        if(imageNameList != "") {
                            // 上傳圖片
                            await this.uploadImages(response.data.savepictureFileNameSetGroupList);
                        }
                        this.setQuestionInfoToModal(this.modalInfoNum);
                       
                    }
                    else if(response.data.result=="NO_LOGIN"){
                        alert(this.$i18n.t('common.PleaseLogin'));
                        router.push({name: process.env.VUE_APP_ROUTER_HOME});
                    }
                    else if(response.data.result=="ERROR") {
                        alert(this.$i18n.t('historyListContent.Modal.Prompt.UploadFailed'));
                    }
                }
                this.isWaitingModalSubmit = false;
            }
            else {
                alert(this.$i18n.t('common.PleaseLogin'));
                router.push({name: process.env.VUE_APP_ROUTER_HOME});
            }
        },
        userScoring(target){
            var score = 5 - parseInt(target);
            this.modalUserScore = score;

            $(".cm-morecontent-user-scoreIcon").parent().removeClass("cm-morecontent-user-score-selected");
            $(".cm-morecontent-user-scoreIcon").each(function(index){
                if (index == target){
                    $(this).parent().addClass("cm-morecontent-user-score-selected");
                }
            });
        },
        async scoreSubmit(){            
            const self = this;
            if(CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE)!==false) {
                this.isWaitingModalSubmit = true;
                // POST Param
                let bodyFormData = new FormData();                
                bodyFormData.append("from", "taiyou2");
                bodyFormData.append("csNum", this.modalInfoNum);
                bodyFormData.append("sendScoreKey", CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE));                
                bodyFormData.append("score", this.modalUserScore);

             
                // Send HTTP POST                
                const response = await axios({
                    method: "post",
                    url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/updateCustomerComplaintScoreAction.shtml",
                    timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                    data: bodyFormData,
                    config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
                }).catch(function(response) {
                    console.log(response);
                    alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
                });

                console.log(response);

                if (response != 'undefined' && response.data.result == "SUCCESS"){
                    this.setQuestionInfoToModal(this.modalInfoNum);
                }
                this.isWaitingModalSubmit = false;
            }else{
                alert(this.$i18n.t('common.PleaseLogin'));
                router.push({name: process.env.VUE_APP_ROUTER_HOME});
            }
            
        }
    },
};
</script>

<style lang="scss">
    .cmv-listcontent {

        #datepicker1>input,
        #datepicker2>input {
            text-align: center;
        }

        .cmv-listcontent-table-top {
            .cmv-listcontent-table-filter .input-group {

                input.form-control,
                div.input-group-append button {
                    height: 26px;
                    font-size: 12px;
                    text-align: center;
                }

                input.form-control {
                    text-align: center;
                }

                div.input-group-append button {
                    padding: 0 10px;
                }
            }

            .cmv-listcontent-table-page select.custom-select {
                height: 26px;
                font-size: 12px;
                padding: 0 10px;
            }
        }

        .cmv-listcontent-table-pagination {
            height: auto;
            color: #c6bdc6;
            text-align: center;
            line-height: 50px;
            font-weight: bold;
            margin: 15px auto;
            overflow: hidden;

            .page-link {
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: #050a0e;
                color: #c6bdc6;
                text-decoration: none;
                background: rgba(0, 0, 0, 0);
                border-color: rgba(0, 0, 0, 0);
            }

            .page-link:hover {
                color: #FFF;
                background-color: #565656;
                text-decoration: none;
                text-align: center;
            }

            .page-item.active .page-link {
                z-index: 1;
                color: #fff;
                border-color: #007bff;
                background-color: rgba(0, 0, 0, 0) !important;
            }

            .page-item.disabled .page-link {
                background: rgba(0, 0, 0, 0);
                border-color: rgba(0, 0, 0, 0);
            }
        }

        .cmv-listcontent-no-data { 
            background-image: url("../assets/images/nodata.png"); 
            background-position: center;
            background-repeat: no-repeat;
            background-size: 80%;
            .cmv-listcontent-inquire-result {
                border-collapse: collapse;
                width: 100%;
                font-size: 18px;
                td, th {
                    border: 1px solid #6B6B6B;
                }
                td {
                    font-size: 18px;
                    text-align: center;
                    color: #c3c3c3;
                    height: 80px;
                    width: 230px;
                }
                th {
                    padding-top: 10px;
                    padding-bottom: 10px;
                    text-align: center;
                    background-color: #4F4F52;
                    color: #c3c3c3;
                    font-weight: normal;
                }
            }
        }

        @media screen and (min-width: 1px) {

            #datepicker1>input,
            #datepicker2>input {
                width: 51vw;
            }

            .cmv-listcontent-table-pagination {
                .page-item a {
                    font-size: 1.4vw;
                }

                .page-link,
                .page-link:hover,
                .page-item.active .page-link {
                    height: 5.2vw;
                    width: 5.2vw;
                    line-height: 2.2vw;
                }
            }

            .cmv-listcontent-inquire-result th {
                    font-size: 2.6vw;
                    padding: 0.3rem;
            }
        }

        @media screen and (min-width: 576px) {

            #datepicker1>input,
            #datepicker2>input {
                width: 19vw;
            }

            .cmv-listcontent-table-pagination {
                .page-item a {
                    font-size: 1.4vw;
                }

                .page-link,
                .page-link:hover,
                .page-item.active .page-link {
                    height: 5.2vw;
                    width: 5.2vw;
                    line-height: 2.2vw;
                }
            }

            .cmv-listcontent-inquire-result th {
                font-size: 1.8vw;
                padding: 0.55rem;
            }
        }

        @media screen and (min-width: 767px) {

            #datepicker1>input,
            #datepicker2>input {
                width: 15vw;
            }

            .cmv-listcontent-table-pagination {
                .page-item a {
                    font-size: 1.4vw;
                }

                .page-link,
                .page-link:hover,
                .page-item.active .page-link {
                    height: 4vw;
                    width: 4vw;
                    line-height: 2.2vw;
                }
            }

            .cmv-listcontent-inquire-result th {
                    font-size: 1.8vw;
                    padding: 0.75rem;
            }
        }

        @media screen and (min-width: 992px) {

            #datepicker1>input,
            #datepicker2>input {
                width: 14vw;
            }

            .cmv-listcontent-table-pagination {
                .page-item a {
                    font-size: 1.4vw;
                }

                .page-link,
                .page-link:hover,
                .page-item.active .page-link {
                    height: 4vw;
                    width: 4vw;
                    line-height: 2.2vw;
                }
            }

            .cmv-listcontent-inquire-result th {
                    font-size: 1.6vw;
            }
        }

        @media screen and (min-width: 1200px) {

            #datepicker1>input,
            #datepicker2>input {
                width: 11.54vw;
                max-width: 235px;
            }

            .cmv-listcontent-table-pagination {
                .page-item a {
                    font-size: 20px;
                }

                .page-link,
                .page-link:hover,
                .page-item.active .page-link {
                    height: 50px;
                    width: 50px;
                    line-height: 30px;
                }
            }

            .cmv-listcontent-inquire-result th {
                    font-size: 20px;
            }
        }
    }
</style>